import get from 'lodash/get';
import reduce from 'lodash/reduce';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cFilterByFields', standalone: false })
export class FilterByFieldsPipe implements PipeTransform {
  transform(items: any[], query: string, fields: string[] = []): any {
    if (!query || !items) {
      return items;
    }

    return items
      .filter((g) => {
        return fields.some((field) => this.test(get(g, field), query));
      });
  }

  test(data: any, query: string) {
    if (!data) {
      return false;
    }

    if (typeof data === 'object' || data.constructor === Array) {
      return reduce(data, (prevValue, value, key) => {
        if (prevValue) {
          return prevValue;
        }

        return this.test(data[key], query);
      }, false);
    }

    if (typeof data === 'string' || typeof data === 'number') {
      return this.testByQuery(data + '', query);
    }

    return false;
  }

  testByQuery(string: string, query: string) {
    const reg = new RegExp(query, 'gi');
    return reg.test(string);
  }
}
